$(document).ready( function() {
	var pageURL = $(location).attr("href");
   	var path = pageURL.replace(/^https?:\/\//, '').split('/');
    if(path[1] == "en"){
        $("#shopify-section-template--14211385491558__video").hide();       
      $("#shopify-section-1535002073948").hide();
      $("#slider").hide();
    }else{
      $("#slider2").hide();
      $("#shopify-section-template--14211385491558__16418998091969fb36").hide();
      
    }
   $('#slider video').attr('playsinline',true);
   $('#slider2 video').attr('playsinline',true);
});